// Hardcoded Vido product catalogue (Phase 1 demo)
// All copy is Swedish; keep concise and believable.

const products = [
  {
    slug: "villa-comfort-25",
    category: "Luft/luftvärmepump",
    name: "Villa Comfort 25",
    shortDescription:
      "För dig som vill ha effektiv uppvärmning på vintern och behaglig svalka på sommaren.",
    forWhom: "Passar villor upp till ca 150 m² med öppen planlösning.",
    benefits: [
      "Värme och kyla året runt",
      "Anpassad för villa",
      "Energieffektiv drift",
    ],
    included: [
      "Standardinstallation",
      "Montering och infästning",
      "Elinkoppling",
      "Funktionskontroll",
      "Genomgång med dig efter installation",
    ],
    price: "24 900 kr",
    priceNote: "efter ROT",
    priceType: "fast",
    image: "/products/villa-comfort-25.png",
  },
  {
    slug: "nordic-vento-300",
    category: "Frånluftsvärmepump",
    name: "Nordic Vento 300",
    shortDescription:
      "En komplett lösning som återvinner värmen ur frånluften och ger varmvatten och uppvärmning.",
    forWhom: "Passar villor med befintligt frånluftssystem, ca 130–180 m².",
    benefits: [
      "Värme och varmvatten i en enhet",
      "Utnyttjar frånluftens värme",
      "Tystgående drift",
    ],
    included: [
      "Standardinstallation",
      "Anslutning till befintligt ventilationssystem",
      "Elinkoppling",
      "Idrifttagning och injustering",
      "Genomgång och skötselråd",
    ],
    price: "44 900 kr",
    priceNote: "efter ROT",
    priceType: "från",
    image: "/products/nordic-vento-300.png",
  },
  {
    slug: "aquaeco-200",
    category: "Varmvattenberedare",
    name: "AquaEco 200",
    shortDescription:
      "En modern varmvattenberedare för hushåll som vill ha jämn tillgång på varmvatten och lägre elförbrukning.",
    forWhom: "Passar hushåll med 2–4 personer.",
    benefits: [
      "Låg energiförbrukning",
      "Snabb återhämtning av varmvatten",
      "Lång livslängd",
    ],
    included: [
      "Standardinstallation",
      "Demontering av gammal beredare",
      "VVS-anslutning",
      "Elinkoppling",
      "Funktionskontroll",
    ],
    price: "18 900 kr",
    priceNote: "efter ROT",
    priceType: "från",
    image: "/products/aquaeco-200.png",
  },
  {
    slug: "climacool-villa",
    category: "AC / kyla för villa",
    name: "ClimaCool Villa",
    shortDescription:
      "Diskret kyla för sovrum och vardagsrum när sommaren blir för varm — utan att förändra rummets uttryck.",
    forWhom: "Passar villor och radhus som behöver kyla enskilda rum eller ett helt plan.",
    benefits: [
      "Snabb och effektiv kyla",
      "Låg ljudnivå inomhus",
      "Diskret design",
    ],
    included: [
      "Standardinstallation",
      "Montering av inne- och utedel",
      "Rördragning och isolering",
      "Elinkoppling",
      "Funktionskontroll och genomgång",
    ],
    price: "22 900 kr",
    priceNote: "efter ROT",
    priceType: "från",
    image: "/products/climacool-villa.png",
  },
  {
    slug: "freshflow-ftx-250",
    category: "Ventilationslösning",
    name: "FreshFlow FTX 250",
    shortDescription:
      "Ett FTX-aggregat som ger frisk luft in och återvinner värmen från frånluften — bättre inomhusklimat och lägre uppvärmningsbehov.",
    forWhom: "Passar villor 120–200 m² som vill förbättra inomhusluften.",
    benefits: [
      "Frisk luft dygnet runt",
      "Återvinner upp till 85 % av värmen",
      "Filtrerar pollen och partiklar",
    ],
    included: [
      "Standardinstallation",
      "Montering av aggregat",
      "Anslutning till befintliga kanaler",
      "Elinkoppling",
      "Injustering och genomgång",
    ],
    price: "32 900 kr",
    priceNote: "efter ROT",
    priceType: "från",
    image: "/products/freshflow-ftx-250.png",
  },
];

export default products;
export const getProduct = (slug) => products.find((p) => p.slug === slug);
